import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Tab, Table, Loader, Divider, Card, Placeholder, Popup
} from 'semantic-ui-react';

// import { fadeIn } from 'react-animations';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import moment from 'moment';
import ActivePollList from '../AdminPoll/PollTabs/ActivePollList';
import CreatedPollList from '../AdminPoll/PollTabs/CreatedPollList';
import ArchivedPollList from '../AdminPoll/PollTabs/ArchivedPollList';
import ReactApexChart from 'react-apexcharts';
import { $ } from 'glamor';
import CourseResults from './CourseResults';
import StaffResults from './StaffResults';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import Responsive from 'semantic-ui-react/dist/commonjs/addons/Responsive';
import SectionTemplate from './SectionTemplate';


export default class CourseResultsOverview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            sections: [],

        };
        this.getSectionForRole = this.getSectionForRole.bind(this);
    }

    componentDidMount() {
        this.getSectionForRole();
    }

    getSectionForRole() {
        axios.get(`/questionnaire/get-sections-by-role/${JSON.parse(localStorage.getItem('poll')).pollType}/`)
            .then(res => {
                let sections = res.data;

                this.setState({
                    sections: sections.sort((a, b) => a.orderNumber - b.orderNumber)
                }, () => {
                    const panes = sections.map((e) => ({
                        menuItem: e.displayName,
                        render: () => (<Tab.Pane attached={false} as={Responsive} >
                            <SectionTemplate sectionId={e.id} />
                        </Tab.Pane>)
                    }));
                    this.setState({ panes, loading: false });
                    if (localStorage.getItem('staffPosition') === 'assistant') {
                        sections = this.state.sections.filter((e) => (e.displayName !== 'Profesor'));
                        const panes = sections.map((e) => ({
                            menuItem: e.displayName,
                            render: () => (<Tab.Pane attached={false} as={Responsive} >
                                <SectionTemplate sectionId={e.id} />
                            </Tab.Pane>)
                        }));
                        this.setState({ panes, loading: false });
                    } else
                    if (localStorage.getItem('staffPosition') === 'professor') {
                        sections = this.state.sections.filter((e) => (e.displayName !== 'Asistent'));
                        const panes = sections.map((e) => ({
                            menuItem: e.displayName,
                            render: () => (<Tab.Pane attached={false} as={Responsive} >
                                <SectionTemplate sectionId={e.id} />
                            </Tab.Pane>)
                        }));
                        this.setState({ panes, loading: false });
                    }
                });
            }).catch(err => {
                console.log('Failed to fetch sections.');
                this.setState({
                    sections: [{
                        id: 2,
                        displayName: 'Profesor Test'
                    }, {
                        id: 3,
                        displayName: 'Predmet Test'
                    }]
                });
            });
    }


    render() {
        const { panes } = this.state;

        return (

            <div>
                <Header as="h2"><FormattedMessage id="poll.pollResults" />

                </Header>
                <Segment.Group clearing raised >
                    <Segment>
                        <Header as="h3">
                            <Header.Content>
                                { localStorage.getItem('pollType') === 'ssp' ? localStorage.getItem('spbName') + '-' + localStorage.getItem('spName') : localStorage.getItem('courseName')}
                            </Header.Content>
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => window.history.go(-1)}
                                    />}
                                    content={<FormattedMessage id="common.back" />}
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <Header.Subheader floated="left">
                                {((localStorage.getItem('staffName')) !== 'null' && localStorage.getItem('pollType') !== 'ssp') ? localStorage.getItem('staffName') : ' '}
                            </Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment>
                        {this.state.loading ?
                            <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                            : <Tab panes={panes} menu={{ secondary: true, pointing: true, color: 'blue' }} defaultActiveIndex={localStorage.getItem('activeRole').substr(0, 14) === 'QA admin - OJ:' ? 0 : 1} />}

                    </Segment>


                </Segment.Group>

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/ProfessorPoll/CourseResultsOverview.js